module.exports = __webpack_public_path__ + "img/napoles.4bbcd708.jpg";